// Exports
export default {
	"premiumButtonContainer": "premiumButtonContainer_Ne76x"
};
